import { CreateExtractTasksMode } from '~src/extract/actions/CreateExtractTaskAction';

import { Messages } from '../../../../codegen/Localize';
import {IDataSourceInfo} from '../../../../datasource/models/IDataSourceInfo';
import {FeatureFlags} from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import {IRefreshExtractAction} from '../../../../ts/ServerApi/types/actionNames';
import {createExtractRefresh} from '../../../actions/spaces/CreateExtractRefreshAction';
import {getAppStore} from '../../../AppStore';
import {SessionSiteSelectors} from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import {currentUserIsOwnerOrAdmin} from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import {isSingleDatasourceWithExtract, isSingleEmbeddedDatasource} from './IEntityActionHelpers';

export const ScheduleRefreshWithBridgeEntityAction: IEntityAction<IDataSourceInfo, IRefreshExtractAction> = {
  name: EntityActionNames.ScheduleRefreshWithBridge,
  translateName: Messages.bridgeLegacySchedule_action,

  isVisible: (targetItems: IDataSourceInfo[], appState: AppState) => {
    const isExtractSSSEnabledForServer = FeatureFlags.selfServiceSchedulesForRefreshEnabled;
    const isExtractSSSEnabledForSite = SessionSiteSelectors.isSelfServiceSchedulesForRefreshEnabled(getAppStore().getState());
    const isExtractSSSEnabled = isExtractSSSEnabledForServer && isExtractSSSEnabledForSite;

    return isExtractSSSEnabled
      && isSingleDatasourceWithExtract(targetItems)
      && !isSingleEmbeddedDatasource(targetItems);
  },

  isClickable: (availableActions: IRefreshExtractAction, targetItems: IDataSourceInfo[]) => {
    const appState = getAppStore().getState();
    return currentUserIsOwnerOrAdmin(appState, targetItems[0]) || (availableActions && availableActions.refreshExtract);
  },

  createReduxAction: (targetItems: IContentInfo[]) => createExtractRefresh(targetItems, CreateExtractTasksMode.AllowScheduleOnlyOnClient)
};
